import theme from '@styles/theme';
export default {
  footerContainer: {
    background: theme.background.footer,
    height: 'auto',
    padding: ['0 16px 24px', '0 16px 24px', '0 24px 24px', '0 40px 24px'],
    position: 'relative'
  },
  footerContainerInner: {
    alignItems: 'center',
    margin: 'auto'
  },
  footerContactContainer: (addPadding?: boolean) => ({
    margin: 'auto',
    padding: ['40px 0', '40px 0', '64px 0', `64px 0 ${addPadding ? '24px' : 0}`],
    borderBottom: ['none', 'none', 'none', `1px solid ${theme.rawColors.darkGrey500}`],
    display: 'flex',
    flexDirection: ['column', 'column', 'column', 'column', 'row'],
    alignItems: 'center',
    justifyContent: ['center', 'center', 'space-between'],
    mb: ['0', '0', '0', '64px']
  }),
  footerMediaContainer: {
    display: 'flex',
    alignSelf: ['center', 'center', 'center', 'center', 'start'],
    height: '32px',
    mt: ['0', '0', '0', '0', '20px'],
    ml: '0',
    justifyContent: 'inherit',
    width: ['auto', 'auto', 'auto', '30%', 'auto'],
    a: {
      p: '0 12px',
      '&:last-child': {
        p: '0 0 0 12px'
      },
      '&:first-child': {
        p: '0 12px 0 0'
      }
    }
  },
  footerMediaLink: {
    height: '32px',
    display: 'flex',
    justifyContent: 'center'
  },
  footerNewsletterContainer: {
    display: 'flex',
    flexDirection: 'column',
    p: ['0 0 41px', '0 0 41px', '0 0px 52px', '0 0 60px'],
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: '18px',
    color: theme.rawColors.darkGrey700,
    width: ['100%', '51ch', '510px', '510px', '596px'],
    maxWidth: '596px'
  },
  newsletterForm: {
    display: 'flex',
    position: 'relative',
    fontSize: '16px',
    p: '10px 12px',
    borderBottom: `1px solid ${theme.rawColors.darkGrey500}`,
    m: ['-20px 0 15px', '0 0 15px'],
    button: {
      mt: ['-12px', '0']
    }
  },
  newsletterPlaceholder: (active: boolean) => ({
    color: theme.rawColors.darkGrey700,
    display: active ? 'none' : 'block',
    position: 'absolute',
    zIndex: theme.zIndex.documentUp + 1,
    width: ['28ch', '90%'],
    height: '42px',
    pt: '10px',
    mt: ['-20px', '0'],
    letterSpacing: theme.letterSpacings.caps,
    '&:hover': {
      cursor: 'text'
    }
  }),
  newsletterInput: {
    p: '8px 0',
    zIndex: theme.zIndex.documentUp + 2,
    width: '100%',
    textAlign: 'start',
    background: 'transparent',
    border: 'none',
    '&::placeholder': {
      color: theme.rawColors.darkGrey700,
      opacity: '0'
    }
  },
  newsletterError: {
    color: theme.rawColors.accent700,
    fontSize: theme.fontSizes.caption,
    mb: '10px',
    mt: '-10px'
  },
  newsletterCheckbox: {
    position: 'relative',
    display: 'flex',
    ml: '5px',
    pb: ['12px', '6px', '0']
  },
  newsletterPolicyWrapper: {
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: '12px',
    color: theme.rawColors.darkGrey700,
    lineHeight: '16px',
    position: 'relative',
    ml: '3px',
    mr: '12px',
    letterSpacing: theme.letterSpacings.caps
  },
  newsletterPolicyLink: {
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: '12px',
    color: theme.rawColors.darkGrey700,
    lineHeight: '16.8px',
    mr: '4px',
    position: 'relative',
    display: 'inline-block',
    '&:after': {
      content: '" "',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      borderBottom: `1px solid ${theme.rawColors.darkGrey700}`,
      width: '100%'
    }
  },
  newsletterThx: {
    minHeight: '100px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  footerContact: {
    paddingBottom: ['40px', '40px', '40px', '0'],
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: '16px',
    color: theme.rawColors.darkGrey700,
    lineHeight: '140%',
    textAlign: ['center', 'center', 'start'],
    display: ['block', 'block', 'flex'],
    width: ['100%', '100%', '100%', '100%', '25%'],
    justifyContent: 'space-between',
    alignSelf: 'start',
    flexDirection: ['column', 'column', 'row', 'row', 'column'],
    mt: ['0', '0', '0', '0', '15px']
  },
  footerGeneralContainer: (keys: number) => ({
    display: ['block', 'block', 'block', 'grid'],
    gridTemplateColumns: ['repeat(1, 1fr)', `repeat(${keys}, 1fr)`],
    gridGap: '20px',
    gridAutoRows: 'minmax(100px, auto)',
    padding: '0'
  }),
  footerGeneralInnerContainer: {
    display: 'flex',
    flexDirection: ['column', 'column', 'row']
  },
  footerGeneralListToogleBlock: {
    width: '100%',
    borderTop: `1px solid ${theme.rawColors.darkGrey500}`
  },
  footerGeneralListWrapper: {
    display: 'flex',
    m: '24px 0',
    alignItems: 'center',
    ':hover': {
      cursor: 'pointer'
    }
  },
  addButton: {
    ml: 'auto',
    pr: '10px'
  },
  footerGeneralListContainer: (index: number) => ({
    gridColumn: [1, index],
    gridRow: [index, 1]
  }),
  footerGeneralList: {
    listStyle: 'none',
    pb: ['24px', '24px', '24px', '0']
  },
  footerGeneralListItem: {
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: '16px',
    color: theme.rawColors.darkGrey700,
    lineHeight: '140%',
    marginBottom: '16px',
    letterSpacing: '0.05em',
    a: {
      color: theme.rawColors.darkGrey700
    }
  },
  footerBottom: (isSimple: boolean) => {
    const flexDirection = (() => {
      if (isSimple) {
        return ['column', 'column', 'row'];
      }
      return 'column';
    })();
    return {
      borderTop: isSimple ? 'none' : [`1px solid ${theme.rawColors.darkGrey500}`, `1px solid ${theme.rawColors.darkGrey500}`, `1px solid ${theme.rawColors.darkGrey500}`, 'none'],
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection,
      p: isSimple ? 0 : ['40px 0', '40px 0', '42px 0 36px', '42px 0 36px', '50px 0 44px']
    };
  },
  footerCopyRights: {
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: '16px',
    color: theme.rawColors.darkGrey700,
    lineHeight: '140%',
    textAlign: 'center',
    width: 'auto',
    pb: ['24px', '24px', '0']
  },
  simpleFooterCopyRights: {
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: '16px',
    color: theme.rawColors.darkGrey700,
    lineHeight: '140%',
    padding: ['40px 0 24px', '40px 0 24px', '39px 0'],
    width: '100%',
    textAlign: 'center'
  },
  footerRegionsContainer: {
    display: 'flex',
    width: ['auto', 'auto', 'auto', 'auto', '100%'],
    flexDirection: ['column', 'column', 'row'],
    justifyContent: ['center', 'center', 'space-between'],
    alignItems: 'center'
  },
  simpleFooterLocale: {
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: '16px',
    color: theme.rawColors.darkGrey700,
    lineHeight: '140%',
    padding: ['0 0 40px', '0 0 40px', 0],
    textAlign: ['center', 'center', 'end'],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    span: {
      textDecoration: 'solid underline #a1a1a1 2px',
      m: '0 3px'
    }
  },
  simpleFooterLocaleIcon: {
    mr: '13px',
    padding: [0, 0, '38px 0']
  },
  chatContainer: {
    mt: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: ['center', 'center', 'start'],
    a: {
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'underline'
    },
    span: {
      fontFamily: theme.fonts.uniform,
      fontWeight: theme.fontWeights.normal,
      fontSize: '16px',
      color: theme.rawColors.darkGrey700,
      textDecorationStyle: 'solid',
      textDecorationColor: '#a1a1a1',
      textDecorationLine: 'underline',
      textDecorationThickness: '2px',
      mr: ['17.67px', '0px', '0px'],
      p: '0 0 0 16px'
    }
  },
  footerPayments: {
    width: '100%',
    position: 'relative',
    mt: '3px',
    justifyContent: 'center',
    display: 'flex',
    flexFlow: 'wrap',
    rowGap: '40px',
    pb: ['38px', '38px', '48px']
  },
  footerPaymentsIcon: (size?: string | string[], moreThanFivePaymentsIcons?: boolean) => ({
    position: 'relative',
    p: '0 20px',
    m: ['0 auto', '0 auto', '0 17px'],
    height: '16px',
    width: moreThanFivePaymentsIcons ? ['20%', '20%', size] : size
  }),
  footerContactPhoneLink: {
    color: theme.rawColors.darkGrey700,
    '&:focus, &:active, &:hover, &:focus': {
      color: theme.rawColors.darkGrey700
    }
  }
};